interface EasyIconProps {
    width: number;
    height: number;
}

const EasyIcon = ({ width, height }: EasyIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 269 230'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M139.641 102.22L245.866 163.526L129.626 227.843L23.4028 161.899L139.641 102.22Z'
                stroke='#E5D8C9'
                strokeWidth='0.781176'
                strokeLinecap='round'
                strokeDasharray='0.78 3.52'
            />
            <path
                d='M39.8937 107.204L156.515 174.616L156.487 206.256L39.8937 138.838L39.8937 107.204Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M78.8132 84.7335L117.733 107.204L117.681 107.234L156.549 129.675L156.531 129.685L195.434 152.145L156.514 174.616L117.594 152.145L117.611 152.135L78.7082 129.675L78.7607 129.644L39.8929 107.204L78.8132 84.7335Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
            />
            <path
                d='M156.514 174.616L195.434 152.146L195.434 183.78L156.514 206.25L156.514 174.616Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M156.514 136.209L184.117 152.145L156.514 168.082L128.911 152.145L156.514 136.209Z'
                fill='white'
            />
            <path
                d='M156.514 136.209L184.117 152.145L156.514 168.082M156.514 136.209L128.911 152.145L156.514 168.082M156.514 136.209L156.514 168.082'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
            />
            <path
                d='M184.117 152.145L156.514 136.209L156.514 168.082L184.117 152.145Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M96.0669 99.1479L84.0292 125.263L50.8344 106.098L96.0669 99.1479Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M94.5854 92.6317L83.9936 115.61L54.7859 98.7469L94.5854 92.6317Z'
                fill='#FFD7A6'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
            />
            <path
                d='M83.9938 115.61L94.5856 92.6317V102.342L83.9938 125.264V115.61Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M54.786 98.7469L83.9937 115.61V125.252L54.786 108.454V98.7469Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M131.711 137.41C123.896 141.922 111.225 141.922 103.41 137.41C95.5949 132.898 95.5949 125.583 103.41 121.071C111.225 116.559 123.896 116.559 131.711 121.071C139.526 125.583 139.526 132.898 131.711 137.41Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
            />
            <path
                d='M98.8238 120.322L136.294 120.183L136.311 133.285C135.34 134.79 133.806 136.201 131.711 137.411C123.896 141.923 111.225 141.923 103.41 137.411C101.297 136.19 99.7553 134.765 98.7849 133.246L98.8238 120.322Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
            />
            <path
                d='M131.711 137.41C133.806 136.201 135.34 134.79 136.312 133.285L136.295 120.183L127.367 120.216V139.316C128.923 138.81 130.387 138.175 131.711 137.41Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
            />
            <path
                d='M130.81 128.048C123.493 132.273 111.629 132.273 104.311 128.048C96.9936 123.823 96.9936 116.973 104.311 112.749C111.629 108.524 123.493 108.524 130.81 112.749C138.127 116.973 138.127 123.823 130.81 128.048Z'
                fill='#98E9AC'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
            />
            <path
                d='M138.881 184.862L131.681 180.705L129.281 182.091L136.481 186.248L138.881 184.862Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M138.881 178.396L131.681 174.24L129.281 175.625L136.481 179.782L138.881 178.396Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M138.881 171.93L131.681 167.773L129.281 169.158L136.481 173.315L138.881 171.93Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M136.481 176.087V179.781L138.88 178.396V174.7L136.481 176.086V176.087ZM136.481 182.553V186.248L138.88 184.863V181.168L136.481 182.553V182.553ZM136.481 182.553L138.88 181.167V178.396L136.481 179.781V182.553ZM136.481 176.087L138.88 174.701V171.93L136.481 173.315V176.087ZM136.481 189.019L138.88 187.634V184.863L136.481 186.248V189.019Z'
                fill='#090B2A'
            />
            <path
                d='M136.481 176.087V179.781M136.481 176.087V176.086L138.88 174.7V178.396M136.481 176.087L138.88 174.701V171.93L136.481 173.315V176.087ZM136.481 179.781L138.88 178.396M136.481 179.781V182.553M138.88 178.396V181.167L136.481 182.553M136.481 182.553V186.248M136.481 182.553V182.553L138.88 181.168V184.863M136.481 186.248L138.88 184.863M136.481 186.248V189.019L138.88 187.634V184.863'
                stroke='black'
                strokeWidth='0.269'
                strokeLinejoin='round'
            />
            <path
                d='M136.48 179.781V176.086V173.315L129.28 169.158V171.929L134.081 174.646V178.395L129.28 175.624V178.395L134.081 181.167V184.862L129.28 182.091V184.862L136.48 189.019V186.248V182.552V179.781Z'
                fill='#EFE8E0'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M96.9854 162.739L92.1854 159.967V156.301L94.5857 157.658L96.9854 159.044V152.578V149.807L89.7856 145.65V148.421L94.5857 151.192V154.887L89.7856 152.116V154.886V154.887V161.353L92.1854 162.739L96.9854 165.51V162.739Z'
                fill='#EFE8E0'
            />
            <path
                d='M89.7856 154.887V161.353L92.1854 162.739L96.9854 165.51V162.739L92.1854 159.967V156.301L94.5857 157.658L96.9854 159.044V152.578V149.807L89.7856 145.65V148.421L94.5857 151.192V154.887L89.7856 152.116V154.887ZM89.7856 154.887V154.886'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M89.7858 145.65L92.1855 144.264L99.3853 148.421L96.9855 149.807L89.7858 145.65Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M99.3851 148.421V157.658L96.9854 159.044V149.807L99.3851 148.421Z'
                fill='#090B2A'
                stroke='black'
                strokeWidth='0.269'
                strokeLinejoin='round'
            />
            <path
                d='M96.9854 162.739L99.3851 161.354V164.125L96.9854 165.511V162.739Z'
                fill='#090B2A'
                stroke='black'
                strokeWidth='0.269'
                strokeLinejoin='round'
            />
            <path
                d='M99.3847 161.353L92.1849 157.197V159.968L96.985 162.739L99.3847 161.353Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
            />
            <path
                d='M89.7857 152.116L92.1855 150.73L94.5852 152.116V154.887L89.785 152.116H89.7857Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M92.1849 159.968V156.272L94.5847 157.658V158.581L92.1849 159.967V159.968Z'
                fill='#090B2A'
            />
            <path
                d='M57.0385 130.451L59.29 129.151V126.55L57.0385 127.85V130.451Z'
                fill='#090B2A'
            />
            <path
                d='M61.5413 142.585L59.2897 143.885V129.15L61.5413 127.85V142.584V142.585Z'
                fill='#090B2A'
                stroke='black'
                strokeWidth='0.269'
                strokeLinejoin='round'
            />
            <path
                d='M57.0381 130.45L54.7869 129.151V126.55L57.0385 127.85V127.851L59.2903 129.151V143.885L57.0381 142.585V130.45Z'
                fill='#EFE8E0'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M57.0375 125.251L54.7859 126.551L59.29 129.151L61.5416 127.851L57.0375 125.251Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <path
                d='M117.776 41.2157C117.879 41.2467 117.975 41.2846 118.072 41.3398L117.776 41.2157Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.216159'
                strokeMiterlimit='10'
            />
            <path
                d='M121.911 55.6645V52.8594L127.211 49.7993C127.376 49.7063 127.535 49.627 127.69 49.5754C127.728 49.5616 127.759 49.5512 127.797 49.5409C128.1 49.4513 128.382 49.4375 128.641 49.4858L129.147 49.6994L131.349 50.6195V50.6298H131.343C131.291 50.623 131.239 50.6195 131.184 50.6195C130.839 50.6195 130.45 50.7263 130.05 50.9606L129.95 51.0192L126.156 53.2144L126.142 53.2212L121.911 55.6645Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.216159'
                strokeMiterlimit='10'
            />
            <path
                d='M103.367 70.1858L103.733 70.3408C103.602 70.3098 103.481 70.2582 103.367 70.1858Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.216159'
                strokeMiterlimit='10'
            />
            <path
                d='M105.245 69.0697C105.245 68.0566 105.549 66.9573 106.034 65.9959C106.551 64.9793 107.279 64.1109 108.085 63.6422L116.228 58.9419V48.0868C116.228 47.4011 116.366 46.6809 116.6 45.9916C116.724 45.6264 116.879 45.268 117.055 44.9268C117.551 43.9826 118.227 43.1831 118.967 42.7145C119.002 42.6938 119.033 42.6766 119.064 42.6559C119.543 42.3768 119.998 42.2768 120.398 42.3285C120.422 42.3285 120.439 42.3354 120.46 42.3389C120.546 42.3561 120.635 42.3802 120.715 42.4078L120.735 42.4181C121.063 42.5491 121.342 42.8041 121.542 43.1659C121.773 43.5794 121.903 44.1342 121.903 44.8028V55.6578L126.135 53.2145L126.149 53.2076L129.943 51.0125L130.043 50.9539C130.443 50.7196 130.832 50.6128 131.177 50.6128C131.232 50.6128 131.284 50.6128 131.335 50.6231H131.342C131.342 50.6231 131.363 50.6231 131.373 50.6231C131.504 50.6369 131.628 50.6714 131.745 50.7196L131.759 50.7265C131.863 50.7747 131.959 50.8299 132.056 50.9023C132.062 50.9023 132.066 50.9126 132.073 50.916C132.259 51.0608 132.414 51.2503 132.538 51.4915C132.555 51.526 132.572 51.557 132.586 51.5915C132.779 51.9878 132.886 52.4978 132.886 53.1008C132.886 55.1926 131.614 57.622 130.046 58.5249L121.907 63.2253V74.0837C121.907 76.1755 120.632 78.6084 119.064 79.5147C118.809 79.6628 118.561 79.7594 118.326 79.8145C118.32 79.8145 118.309 79.8145 118.302 79.8145C118.082 79.8627 117.868 79.8662 117.672 79.8317C117.462 79.7938 117.265 79.7111 117.093 79.587C117.058 79.5629 117.027 79.5354 116.993 79.5078C116.979 79.5009 116.965 79.4871 116.952 79.4733C116.91 79.4389 116.876 79.4044 116.838 79.3596C116.796 79.3148 116.762 79.27 116.724 79.2183C116.686 79.1701 116.655 79.1184 116.624 79.0632C116.528 78.8978 116.442 78.7118 116.383 78.5016C116.362 78.4326 116.342 78.3602 116.324 78.2879C116.259 78.0088 116.228 77.7021 116.228 77.3609V66.5059L113.385 68.1462L108.081 71.2063C107.778 71.382 107.485 71.4854 107.21 71.5268C106.948 71.5681 106.7 71.5474 106.479 71.4682L106.276 71.3855L106.265 71.3786C105.824 71.1408 105.497 70.6618 105.342 69.9864C105.276 69.7107 105.245 69.4006 105.245 69.0594V69.0697Z'
                fill='#98E9AC'
                stroke='#090B2A'
                strokeWidth='0.216159'
                strokeMiterlimit='10'
            />
            <path
                d='M113.388 76.2072V68.1573L116.231 66.517V77.372C116.231 77.7097 116.266 78.0198 116.328 78.299C116.345 78.3713 116.366 78.4437 116.386 78.5126C116.448 78.7194 116.531 78.9089 116.628 79.0743C116.659 79.1295 116.69 79.1812 116.728 79.2294C116.765 79.2811 116.8 79.3259 116.841 79.3707C116.879 79.4155 116.914 79.4499 116.955 79.4844C116.969 79.4982 116.983 79.512 116.996 79.5189C117.017 79.543 117.041 79.5602 117.062 79.5775C117.069 79.5775 117.062 79.5878 117.055 79.5843L114.929 78.6918L114.181 78.3748C113.947 78.1852 113.75 77.913 113.616 77.565C113.616 77.5581 113.609 77.5512 113.609 77.5443C113.464 77.1756 113.388 76.7241 113.388 76.2072Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.216159'
                strokeMiterlimit='10'
            />
            <path
                d='M102.403 67.9049C102.403 65.8132 103.674 63.3837 105.242 62.4774L113.385 57.777V46.922C113.385 45.8744 113.706 44.7441 114.216 43.7654C114.732 42.7833 115.442 41.9494 116.225 41.498C116.38 41.4118 116.531 41.336 116.673 41.2843C117.072 41.1396 117.445 41.1189 117.768 41.2188L118.065 41.3429L120.398 42.3216C120.398 42.3216 120.405 42.3354 120.398 42.3354C119.998 42.2837 119.547 42.387 119.064 42.6627C119.03 42.6834 118.999 42.7006 118.968 42.7213C118.227 43.1865 117.551 43.9894 117.055 44.9337C116.876 45.2714 116.724 45.6332 116.6 45.9985C116.366 46.6877 116.228 47.4079 116.228 48.0937V58.9487L108.085 63.6491C107.279 64.1143 106.552 64.9861 106.035 66.0027C105.549 66.9642 105.246 68.0634 105.246 69.0766C105.246 69.4143 105.28 69.7279 105.342 70.0036C105.497 70.679 105.824 71.158 106.266 71.3958L103.753 70.3551L103.733 70.3482L103.367 70.1931C103.016 69.9898 102.74 69.6176 102.578 69.1111C102.465 68.7733 102.403 68.3701 102.403 67.9084V67.9049Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.216159'
                strokeMiterlimit='10'
            />
            <path
                d='M155.595 91.522L180.402 105.844L180.402 129.57L155.595 115.248L155.595 91.522Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <rect
                width='28.6449'
                height='28.6449'
                transform='matrix(0.866025 0.5 -0.866025 0.5 180.323 77.2767)'
                fill='#9D94D7'
                stroke='#090B2A'
                strokeWidth='0.259392'
                strokeMiterlimit='10'
            />
            <path
                d='M180.33 105.921L205.138 91.5986L205.138 115.164L180.33 129.486L180.33 105.921Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.269'
                strokeMiterlimit='10'
                strokeLinejoin='round'
            />
            <g clipPath='url(#clip0_7093_55966)'>
                <mask
                    id='mask0_7093_55966'
                    style={{ maskType: 'luminance' }}
                    maskUnits='userSpaceOnUse'
                    x='168'
                    y='55'
                    width='10'
                    height='11'
                >
                    <path
                        d='M177.879 55.7218H168.125V65.4763H177.879V55.7218Z'
                        fill='white'
                    />
                </mask>
                <g mask='url(#mask0_7093_55966)'>
                    <path
                        d='M172.511 56.0207C172.717 55.6222 173.287 55.6222 173.493 56.0207L174.805 58.5586C174.858 58.6603 174.941 58.7432 175.043 58.7958L177.58 60.108C177.979 60.3141 177.979 60.884 177.58 61.0901L175.043 62.4023C174.941 62.4549 174.858 62.5377 174.805 62.6395L173.493 65.1773C173.287 65.5759 172.717 65.5759 172.511 65.1773L171.199 62.6395C171.146 62.5377 171.063 62.4549 170.962 62.4023L168.424 61.0901C168.025 60.884 168.025 60.3141 168.424 60.108L170.962 58.7958C171.063 58.7432 171.146 58.6603 171.199 58.5586L172.511 56.0207Z'
                        fill='#9D94D7'
                    />
                </g>
            </g>
            <g clipPath='url(#clip1_7093_55966)'>
                <mask
                    id='mask1_7093_55966'
                    style={{ maskType: 'luminance' }}
                    maskUnits='userSpaceOnUse'
                    x='237'
                    y='98'
                    width='9'
                    height='9'
                >
                    <path
                        d='M245.33 98.2239H237.527V106.027H245.33V98.2239Z'
                        fill='white'
                    />
                </mask>
                <g mask='url(#mask1_7093_55966)'>
                    <path
                        d='M241.429 103.635C238.095 108.164 235.392 105.461 239.92 102.126C235.39 98.7907 238.093 96.0885 241.429 100.616C244.764 96.087 247.467 98.7907 242.939 102.126C247.465 105.461 244.762 108.164 241.429 103.635Z'
                        fill='#98E9AC'
                    />
                </g>
            </g>
            <g clipPath='url(#clip2_7093_55966)'>
                <mask
                    id='mask2_7093_55966'
                    style={{ maskType: 'luminance' }}
                    maskUnits='userSpaceOnUse'
                    x='130'
                    y='85'
                    width='11'
                    height='10'
                >
                    <path
                        d='M140.012 85.0077H130.257V94.7622H140.012V85.0077Z'
                        fill='white'
                    />
                </mask>
                <g mask='url(#mask2_7093_55966)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M135.135 94.7622C137.828 94.7622 140.012 92.5785 140.012 89.8849C140.012 87.1913 137.828 85.0077 135.135 85.0077C132.441 85.0077 130.257 87.1913 130.257 89.8849C130.257 92.5785 132.441 94.7622 135.135 94.7622ZM135.135 92.0187C136.313 92.0187 137.268 91.0634 137.268 89.8849C137.268 88.7065 136.313 87.7511 135.135 87.7511C133.956 87.7511 133.001 88.7065 133.001 89.8849C133.001 91.0634 133.956 92.0187 135.135 92.0187Z'
                        fill='#EFE8E0'
                    />
                </g>
            </g>
            <defs>
                <clipPath id='clip0_7093_55966'>
                    <rect
                        width='9.75446'
                        height='9.75446'
                        fill='white'
                        transform='translate(168.125 55.7218)'
                    />
                </clipPath>
                <clipPath id='clip1_7093_55966'>
                    <rect
                        width='7.80357'
                        height='7.80357'
                        fill='white'
                        transform='translate(237.527 98.2239)'
                    />
                </clipPath>
                <clipPath id='clip2_7093_55966'>
                    <rect
                        width='9.75446'
                        height='9.75446'
                        fill='white'
                        transform='translate(130.257 85.0077)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default EasyIcon;
